export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13288.4d6ad994.jpg";